<template>
  <v-app>
    <!-- Barra do topo -->
    <v-app-bar color="primary" elevation="2" style="position: sticky !important;">
      <!-- Avatar / logo -->
      <v-avatar size="48">
        <v-img src="@/assets/icons/icon_P BRANCO 3.png" alt="Dreamdeal logo" />
      </v-avatar>

      <v-spacer />

      <!-- Links (ocultados na página de privacidade) -->
      <template v-if="!isPrivacy">
        <p class="mt-4">
          <a class="font-weight-light text-white" @click="getHome">
            {{ $t('menuv2.home') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goPlace('utility')">
            {{ $t('menuv2.utility') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goPlace('portfolio')">
            {{ $t('menuv2.portfolio') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goPlace('team')">
            {{ $t('menuv2.team') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a
            class="font-weight-light text-white"
            @click="goPlace('technologies')"
          >
            {{ $t('menuv2.technologies') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goPlace('faq')">
            {{ $t('menuv2.faq') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goNamed('contacts')">
            {{ $t('menuv2.contacts') }}
          </a>
        </p>

        <p class="ml-16 mt-4">
          <a class="font-weight-light text-white" @click="goNamed('blog')">
            {{ $t('menuv2.blog') }}
          </a>
        </p>
      </template>

      <!-- Botão da bandeira -->
      <p class="mt-4 ml-6">
        <v-btn variant="text" color="black" icon @click="emitSwitchLocale">
          <flag :iso="chooseLanguage" class="elevation-10" />
        </v-btn>
      </p>
    </v-app-bar>

    <!-- Conteúdo da rota -->
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

// router & i18n
const route = useRoute()
const router = useRouter()
const { locale } = useI18n({ useScope: 'global' })

// emitir evento para o pai
const emit = defineEmits(['switchLocale'])
function emitSwitchLocale () {
  emit('switchLocale')
}

// esconder links na rota de privacidade
const isPrivacy = computed(() => route.name === 'privacy')

// alternar bandeira
const chooseLanguage = computed(() => (locale.value === 'pt' ? 'gb' : 'pt'))

// helpers de navegação
function getHome () {
  router.push({ name: 'home', params: { lang: String(locale.value || 'pt') } })
}
function goPlace (place) {
  router.push({
    name: 'home-place',
    params: { lang: String(locale.value || 'pt'), place }
  })
}
function goNamed (name) {
  router.push({ name, params: { lang: String(locale.value || 'pt') } })
}
</script>

<style scoped>

</style>
